module.exports = __webpack_public_path__ + "static/img/pic_rjyf_rjys_ryzz@2x.2db1535a.png";